/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { Component, Inject, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonStyle } from 'src/aero/aero-button/aero-button.component';
import { HttpClient } from '@angular/common/http';
import { BULB_BUSY_COVER_SERVICE } from '../../app/angularjs.providers';
import { Resume } from '../resume.model';
import { ResumeService } from '../resume.service';

/**
 * Visual component for the pop up modal to edit social profile for resumé.
 */
@Component({
  selector: 'bulb-resume-social-dialog',
  templateUrl: './social-profile-dialog.component.html',
  standalone: false,
})
export class ResumeSocialProfileDialogComponent implements OnInit {
  /**
   * Regex for the LinkedIn.
   */
  public linkedinRegex: RegExp = /^(?:(?:http|https):\/\/)?(([-a-zA-Z0-9]{1,}\.)?)?linkedin\S*$/;

  /**
   * Regex for the instagram.
   */
  public instagramRegex: RegExp = /^(?:(?:http|https):\/\/)?(([-a-zA-Z0-9]{1,}\.)?)?instagram\S*$/;

  /**
   * Regex for the twitter|X.
   */
  public twitterRegex: RegExp = /^(?:(?:http|https):\/\/)?(([-a-zA-Z0-9]{1,}\.)?)?(twitter|x)\S*$/;

  /**
   * Regex for the facebook.
   */
  public facebookRegex: RegExp = /^(?:(?:http|https):\/\/)?(([-a-zA-Z0-9]{1,}\.)?)?facebook\S*$/;

  /**
   * Regex for the website.
   */
  public websiteRegex: RegExp = /^(?:(?:http|https):\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  /**
   * User's resume reference.
   */
  public resume: any;

  /**
   *  Resume share detail object
   */
  public resumeShareDetail: Resume = new Resume();

  /**
   * ButtonStyle enum to get types from aero button for template
   */
  public cancelButtonStyle: ButtonStyle = ButtonStyle.GREY;

  constructor(
    @Inject(BULB_BUSY_COVER_SERVICE) private bulbBusyCoverService,
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private resumeService: ResumeService,
    private http: HttpClient,
  ) {
  }

  /**
   * A lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   */
  ngOnInit(): void {
    this.resume = this.dialogConfig.data.resume;
    this.resumeShareDetail = { ...this.resume };
  }

  /**
   * Close reference to resume social profile dialog.
   *
   * @param resume object of the author
   */
  closeSocialProfileDialog(resume?: Resume): void {
    this.dynamicDialogRef.close(resume);
  }

  /**
   * Submit the social profiles for the resume.
   */
  submitSocialProfiles() {
    this.resume.facebook = this.resumeShareDetail.facebook || null;
    this.resume.linkedin = this.resumeShareDetail.linkedin || null;
    this.resume.instagram = this.resumeShareDetail.instagram || null;
    this.resume.twitter = this.resumeShareDetail.twitter || null;
    this.resume.website = this.resumeShareDetail.website || null;

    this.bulbBusyCoverService.showBusyDuring(
      this.http.put(`resumes/${this.resume.id}`, this.resume).toPromise().then((resume : Resume) => {
        this.resumeService.isResumeContactUpdated = true;
        this.closeSocialProfileDialog(resume);
      }),
    );
  }
}
